import { j as e } from "../../jsx-runtime-B6kdoens.js";
import { forwardRef as N, useState as k, useCallback as y, useRef as C, Children as x, useMemo as g } from "react";
import { a as b, c as R } from "../../index-CROKJrb5.js";
import { c as j, f as h } from "../../create-component-CBAeEoQ6.js";
import { u as A } from "../../use-resize-observer-C4bVmnEB.js";
import { u as L } from "../../use-debounce-CdWiiBgU.js";
import { Typography as z } from "../Typography/index.js";
const B = () => /* @__PURE__ */ e.jsx(
  "span",
  {
    "aria-hidden": !0,
    "data-bullet": !0,
    className: "cur-mr-2 cur-text-surface-brand-accent",
    children: "•"
  }
), v = ({
  children: s
}) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  /* @__PURE__ */ e.jsx(B, {}),
  /* @__PURE__ */ e.jsx(z, { children: "..." }),
  /* @__PURE__ */ e.jsx("div", { className: "cur-hidden", children: s })
] }), w = N(({ children: s, className: r, ...t }, a) => /* @__PURE__ */ e.jsx(
  "ul",
  {
    className: b(
      "cur-m-0 cur-flex cur-w-full cur-items-center cur-p-0",
      r
    ),
    ref: a,
    ...t,
    children: s
  }
)), m = ({
  children: s,
  ...r
}) => /* @__PURE__ */ e.jsx(
  "li",
  {
    ...r,
    className: "cur-flex cur-flex-initial cur-list-none cur-flex-nowrap cur-items-center cur-p-0 cur-pl-2 cur-underline-offset-2 first:cur-pl-0 [&>[data-bullet]]:first:cur-hidden",
    children: s
  }
), F = (s, r, [t, a]) => g(() => {
  var f;
  const l = t.length - 1, u = ((f = s.current) == null ? void 0 : f.offsetWidth) || 0;
  let n = t[0] + t[l];
  const c = [r[0], r[l]], i = [];
  if (!u) return [c, []];
  let d = !1;
  for (let o = 1; o < t.length - 1; o += 1) {
    if (d) {
      i.unshift(r[o]);
      continue;
    }
    if (n += t[o], n > u) {
      i.unshift(r[o]);
      const p = !(n - t[o - 1] + a > u && c.length !== 2);
      p || i.unshift(r[o - 1]), c.splice(1, p ? 0 : 1, null), d = !0;
      continue;
    }
    c.splice(-1, 0, r[o]);
  }
  return [c, i];
}, [s, t, a, r]), S = ({ originalWidths: s, children: r, ...t }) => {
  const a = C(null), [l, u] = F(
    a,
    x.toArray(r),
    s
  );
  return /* @__PURE__ */ e.jsx(
    w,
    {
      ref: a,
      className: "cur-z-5 cur-flex-nowrap",
      ...t,
      children: l.map((n, c) => /* @__PURE__ */ e.jsx(m, { children: n === null ? /* @__PURE__ */ e.jsx(v, { children: u }) : n }, c))
    }
  );
}, W = ({ onWidthsChange: s, children: r, ...t }) => {
  const l = L(([
    { target: n }
  ]) => {
    var c;
    s == null || s([
      Array.from(
        n.querySelectorAll("li:not([data-ellipsis]")
      ).map((i) => i.offsetWidth),
      ((c = n.querySelector("li[data-ellipsis")) == null ? void 0 : c.offsetWidth) || 0
    ]);
  }, 50), [u] = A(l);
  return /* @__PURE__ */ e.jsxs(
    w,
    {
      ref: u,
      className: "cur-invisible cur-absolute cur-left-0 cur-top-0 cur-z-0",
      "aria-hidden": !0,
      ...t,
      children: [
        x.map(r, (n, c) => /* @__PURE__ */ e.jsx(m, { children: n }, c)),
        /* @__PURE__ */ e.jsx(m, { "data-ellipsis": !0, children: /* @__PURE__ */ e.jsx(v, {}) })
      ]
    }
  );
}, q = R({
  base: "cur-h-auto cur-whitespace-nowrap cur-px-0 cur-py-0 cur-text-subtle cur-decoration-black cur-decoration-solid cur-decoration-1 cur-transition-all hover:cur-decoration-2 hover:[text-decoration-skip-ink:none] cur-underline-offset-4",
  variants: {
    clickable: {
      true: "cur-cursor-pointer cur-underline"
    }
  }
}), V = j(
  "Breadcrumb",
  h(
    ({ as: s, href: r, className: t, onClick: a, ...l }, u) => {
      const n = !r && !a, c = s || (r ? "a" : "button"), i = q({
        clickable: !!r || !!a,
        className: t
      });
      return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(B, {}),
        /* @__PURE__ */ e.jsx(
          c,
          {
            href: r,
            disabled: n,
            onClick: a,
            className: i,
            ...l,
            ref: u
          }
        )
      ] });
    }
  )
), G = j(
  "Breadcrumbs",
  h(
    ({ as: s, children: r, className: t, ...a }, l) => {
      const u = s || "nav", [n, c] = k([[], 0]), i = y((d) => c(d), []);
      return /* @__PURE__ */ e.jsxs(
        u,
        {
          ref: l,
          className: b("cur-relative cur-overflow-x-clip", t),
          ...a,
          children: [
            /* @__PURE__ */ e.jsx(S, { originalWidths: n, children: r }),
            /* @__PURE__ */ e.jsx(W, { onWidthsChange: i, children: r })
          ]
        }
      );
    }
  )
);
export {
  V as Breadcrumb,
  G as Breadcrumbs
};
//# sourceMappingURL=index.js.map
